export const dashboardEventTypes = {
  MODULE_OPEN: "dashboard-module-open",
  TAB_OPEN: "dashboard-tab-open",
  EMPTY_STATE: "dashboard-empty-state-click",
  CHART_USED: "dashboard-chart-used",
};

export const dashboardTabSubTypes = {
  UP_SMART: "single-tab-up_and_smart",
  STRATEGIC_TAB: "strategic-tab",
  PERSONAL_TAB: "personal-tab",
  OFFICE_TAB: "office-tab",
};

export const dashboardChartFilterAndActionTypes = {
  DATE_RANGE: "filter-date-range",
  LAWSUIT_TYPE: "filter-lawsuit-type",
  CUSTOMER_SEARCH: "filter-customer-search",
  LAWSUIT_COUNTER: "filter-lawsuit-counter",
  RESPONSIBLE: "filter-responsible",
  CALENDAR_ACTIVITY_TYPE: "filter-calendar-activity-type",
  TOGGLE_TIP_OPENED: "action-toggle-tip-opened",
  HELP_CENTER_CLICK: "action-helpcenter-click",
  LEGEND_CLICK: "legend-click",
};

export const dashboardChartEmptyStatesTypes = {
  HELP_CENTER: "helpcenter-click",
  DISCOVER_NEW_PLANS: "discover-new-plans",
  CHECK_RESOURCES: "check-resources",
};
